import React, { useState } from "react";
import CreateUser from "./CreateUser";

const Header = () => {
  const [openCreateUserDialogBox, setOpenCreateUserDialogBox] = useState(false);
  const refreshPage = () => {
    window.location.reload();
  };
  return (
    <>
      <div className="px-0 sm:px-4 space-y-6">
        <div className="flex justify-between gap-2">
          <h1 className="text-2xl leading-9 font-bold sm:text-3xl text-text1">
            Manage users
          </h1>
          <div>
            <button
              className="text-white text-sm bg-primary px-3 py-2 rounded-md"
              onClick={() => setOpenCreateUserDialogBox(true)}
            >
              Create user
            </button>
          </div>
        </div>
        <hr />
      </div>

      {openCreateUserDialogBox && (
        <CreateUser
          closeModal={() => {
            setOpenCreateUserDialogBox(false);
          }}
            refreshData={()=> refreshPage()}
        />
      )}
    </>
  );
};

export default Header;
